import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { ReportDataService } from '../../report-data.service';
import { GaEventService } from '../../../services/ga-event.service';

const APPEND_COMMENT:string = 'APPEND';
const PREPEND_COMMENT:string = 'PREPEND';
const REPLACE_COMMENT:string = 'REPLACE';

@Component({
  selector: 'add-order-comment-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class AddOrderCommentActionComponent extends BaseReportActionsDialog implements OnInit {
  constructor(
    private formlyService: GaFormlyService,
    private reportDataService: ReportDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // create fields
    this.createFields();
  }

  private createFields(): void {
    const commonStepWarning: IExtraFieldConfigurationObject = this.formlyService.aTemplate(`
      <div class="alert alert-warning">
        <i class="fa fa-warning"></i> If you don’t select a 'Common step', the comment will be added to the most recent active status of the selected order(s).
      </div>
    `)
      .withHideExpression(() => !!(this.actionDialogParams?.hideWorkflow))
      .build();

    const commonStep: IExtraFieldConfigurationObject = this.formlyService.aSelect('stepDefId', 'Common step')
      .isDisabled()
      .isLoading()
      .withLabelProp('value')
      .withValueProp('id')
      .withHideExpression(() => !!(this.actionDialogParams?.hideWorkflow))
      .build();

    if (!this.actionDialogParams?.hideWorkflow) {
      this.reportDataService.loadReportActionInfo(this.reportId, this.action.id, this.rowSelection)
        .then((result) => {
          commonStep.templateOptions.options = result.info;
        })
        .finally(() => {
          commonStep.templateOptions.disabled = false;
          commonStep.templateOptions.loading = false;
        });
    }

    this.fields = [
      commonStepWarning,
      commonStep,
      this.formlyService.aTextarea('comments', 'Comments').isRequired().build(),
      this.createCommentTypeRadio('Prepend', PREPEND_COMMENT),
      this.createCommentTypeRadio('Append', APPEND_COMMENT),
      this.createCommentTypeRadio('Replace', REPLACE_COMMENT)
    ];
  }

  private createCommentTypeRadio(label: string, option: string): IExtraFieldConfigurationObject {
    return this.formlyService.aRadioButton('commentsType', label)
      .isRequired()
      .withOption(option)
      .withoutWrapper()
      .build();
  }
}